import { render, staticRenderFns } from "./_ReminderNotifications.vue?vue&type=template&id=cd6b1eca"
import script from "./_ReminderNotifications.vue?vue&type=script&lang=js"
export * from "./_ReminderNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports